import { render, staticRenderFns } from "./CargarTXT.vue?vue&type=template&id=71ab9d12&scoped=true&"
import script from "./CargarTXT.vue?vue&type=script&lang=js&"
export * from "./CargarTXT.vue?vue&type=script&lang=js&"
import style0 from "./CargarTXT.vue?vue&type=style&index=0&id=71ab9d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab9d12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCardText,VContainer,VFlex,VIcon,VLayout})
